import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'aa-routlet',
    template: '<router-outlet [name]="name"></router-outlet>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RoutletComponent
{
    @Input() public name: string;
}
